import { Img } from "../Img";
import { Text } from "../Text";
import { formatCurrency } from "../../helpers/number";
import React from "react";

export function CartPreviewItem({ image, name, amount, quantity }) {
  return (
    <div className="flex flex-1 md:flex-col flex-row md:gap-5 items-start justify-start w-full">
      <Img
        className="h-[100px] mr-[16px] rounded-lg object-contain w-[136px]"
        src={image}
        alt="rectanglesevent"
      />
      <div className="flex md:flex-1 flex-col items-start grow justify-start">
        <Text
          className="text-black-900_dd text-xl tracking-[0.10px]"
          size="txtInterMedium20"
        >
          {name}
        </Text>
        <div className="flex flex-col items-center justify-start mt-[16px] whitespace-nowrap">
          <div className="flex flex-row items-start justify-evenly w-full">
            <Text
              className="text-blue_gray-700 text-xs tracking-[0.40px]"
              size="txtInterRegular12"
            >
              TZS
            </Text>
            <Text
              className="text-black-900_dd text-xl ml-1 tracking-[0.15px]"
              size="txtInterMedium20"
            >
              {formatCurrency(amount)}
            </Text>
          </div>
        </div>
      </div>
      <Text>
        Qty : {formatCurrency(quantity)}
      </Text>
    </div>
  );
}